import React from "react";

const V2MigrationBanner = ({ text }) => {
  return (
    <div
      className={`flex items-center space-x-2 rounded bg-yellow-100 px-3 py-2 text-yellow-600`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-[7%]"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
        />
      </svg>
      <span className="w-[93%] text-sm">
        {text ??
          "Mulai 1 Januari, Semua transaksi & perubahan data kecuali withdrawal hanya dapat dilakukan melalui "}
        <a
          href="http://dompet.kar-tini.id"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#4CA6F8]"
        >
          Dompet Kartini V2
        </a>
      </span>
    </div>
  );
};

export default V2MigrationBanner;
